import { useLocalize } from '@treams/treams-hooks/useLocalize';
import * as graphql from '@treams/treams-network';
import { Paragraph } from '@treams/treams-ui/common/Text';

export default function MultipleChoice(props: { item: graphql.EvaluationMultipleChoiceItem }) {
	const { localize } = useLocalize();

	return <Paragraph>{localize(props.item.title).text}</Paragraph>;
}
